module.exports = __webpack_public_path__ + "static/img/dataImg.66fb991.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/dataImg.webp
// module id = XJjT
// module chunks = 1